import EmailSavedRowsList from '@/modules/email-saved-rows/pages/EmailSavedRowsListPage'
import EmailSavedRowsForm from '@/modules/email-saved-rows/pages/EmailSavedRowsFormPage'

export default [
  {
    name: 'EmailSavedRows',
    path: '/content/email-saved-rows/index',
    component: EmailSavedRowsList,
    meta: {
      auth: ['EmailSavedRows::Read'],
      title: 'Email Saved Rows List'
    }
  },
  {
    name: 'EmailSavedRowsUpdate',
    path: '/content/email-saved-rows/update',
    component: EmailSavedRowsForm,
    meta: {
      auth: ['EmailSavedRows::Update'],
      title: 'Email Saved Row Update'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/email-saved-rows/router/index.js